import { useEffect, useState } from 'react'

export interface Countdown {
  hours: string
  minutes: string
  seconds: string
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

/**
 * Counts down from a fixed number of seconds, stopping at zero.
 */
export function useCountdown(startSeconds: number): Countdown {
  const [remaining, setRemaining] = useState(startSeconds)

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining((current) => (current <= 0 ? 0 : current - 1))
    }, 1000)
    return () => window.clearInterval(timer)
  }, [])

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
